
import React from 'react';
import { AppData } from '@/utils/storage';
import { TrophyCase } from '../rewards';
import StarHistoryBarGraph from '../rewards/StarHistoryBarGraph';
import { AchievementData } from '../rewards/Achievement';

interface StatsTabProps {
  data: AppData;
  editMode?: boolean;
  onEdit?: (achievement: AchievementData) => void;
  onDelete?: (id: string) => void;
  onMoveUp?: (id: string) => void;
  onMoveDown?: (id: string) => void;
  onAddNew?: () => void;
}

const StatsTab: React.FC<StatsTabProps> = ({ 
  data, 
  editMode = false,
  onEdit,
  onDelete,
  onMoveUp,
  onMoveDown,
  onAddNew
}) => {
  // Convert from Achievement type to AchievementData type
  const achievementData: AchievementData[] = (data.achievements || []).map(a => ({
    ...a,
    description: a.description || '', // Convert optional to required field
    requiredStars: a.requiredStars || 0, // Ensure requiredStars is not undefined
    order: a.order, // Pass through the order property if it exists
  }));

  return (
    <>
      {/* Trophy Case */}
      <div className="mb-6">
        <TrophyCase 
          achievements={achievementData} 
          totalStars={data.stars} 
          tasks={data.tasks}
          starHistory={data.starHistory || []}
          totalStarsEarned={data.totalStarsEarned || 0}
          editMode={editMode}
          onEdit={onEdit}
          onDelete={onDelete}
          onMoveUp={onMoveUp}
          onMoveDown={onMoveDown}
          onAddNew={onAddNew}
        />
      </div>

      {/* Star History Visualization */}
      {data.starHistory && data.starHistory.length > 0 && (
        <div className="mb-6">
          <StarHistoryBarGraph 
            starHistory={data.starHistory} 
            theme={data.theme} 
          />
        </div>
      )}
    </>
  );
};

export default StatsTab;
